import { Row, Col } from "antd";
import { withTranslation } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import {
  FooterSection,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Empty,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: any) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <Empty />
              <Language>{t("Address")}</Language>
              <Para>End. Bairro Poção,</Para> 
              <Para>AV. Desembargador Antônio Quirino de Araújo,</Para>
              <Para>Edifício Pantanal Office, sala 2, CEP 78015-580</Para>
              <Para>Cuiabá-MT</Para>
            </Col>
            </Row>
            <Row
            style={{ paddingTop: "3rem" }}
            >
            <Col lg={6} md={6} sm={12} xs={12}>
              <Label htmlFor="select-lang">{t("Language")}</Label>
              <LanguageSwitchContainer>
                <LanguageSwitch onClick={() => handleChange("pt")}>
                  <SvgIcon
                    src="/img/svg/brazil.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                  </LanguageSwitch>
                  <LanguageSwitch onClick={() => handleChange("en")}>
                  <SvgIcon
                    src="/img/svg/united-states.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
                <LanguageSwitch onClick={() => handleChange("es")}>
                  <SvgIcon
                    src="/img/svg/spain.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
              </LanguageSwitchContainer>
            </Col>
          </Row>
        </Container>
      </FooterSection>
      <Extra
      style={{ paddingTop: "2.5rem"}} 
      >
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
                <SvgIcon
                  src="/img/svg/logo.svg"
                  aria-label="homepage"
                  width="101px"
                  height="64px"
                />
              </LogoContainer>
            </NavLink>
            <FooterContainer>
            <SocialLink
                href="https://wa.me/5565996285987?text=Olá,%20vim%20pelo%20site."
                src="/img/svg/whatsapp.svg"
              />
              <SocialLink
                href="https://instagram.com/almeidaadvocacia10"
                src="/img/svg/instagram.svg"
              />              
            </FooterContainer>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
